<template>
    <el-form :model="data" :rules="retailerAddrRules" :label-position="'left'" ref="retailerAddrInfo">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>地址别名</label>
                </div>
                <div class="form-value  width-2x">
                    <el-form-item prop="alias">
                        <el-input v-model="data.alias" placeholder="请输入别名"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">公司地址</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item>
                        <swb-region :item="data" ref="swb_region"></swb-region>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">详细地址</label>
                </div>
                <div class="form-value  width-2x">
                    <el-form-item prop="street">
                        <el-input v-model="data.street" placeholder="请输入地址"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import retailerApi from '../../api/retailer'

    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);

    import SwbRegion from '../comn/Region';
    Vue.regist(SwbRegion);

    export default {
        name: 'swb-save-retailer-addr',
        desc: '零售商业务地址-保存、修改',
        props: ['item'],
        data: function () {
            let checksiteUrl = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            return {
                data: {
                    type: null
                },
                retailerAddrRules: {
                    street: [{
                        validator: checksiteUrl,
                        trigger: 'blur'
                    }],
                },
            }
        },
        created: function () {
            let item = this.item;
            if(item && item.id) {
                let self = this;
                let postData = {};
                postData.retailerAddrId = item.id;
                let theLoad = MsgBox.loading();
                retailerApi.getRetailerAddrInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.data = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        },
        methods: {
            getDlgResult: function () {
                let self = this;
                let regionResult = self.$refs.swb_region.getDlgResult() || {};
                let result = {};
                if(regionResult.data.regionId === null) {
                    result.type = "warn";
                    result.message = "公司地址不能为空";
                    return result;
                }
                this.$refs['retailerAddrInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        self.data.regionId = regionResult.data.countyId;
                        result.data = self.data;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            },
        },
    }
</script>





// WEBPACK FOOTER //
// src/compo/retailer/SaveRetailerAddr.vue